<template>
  <v-app>
    <NavBar v-if="authenticated"></NavBar>
    <v-content :class="this.$router.currentRoute.name">
      <router-view/>
    </v-content>
    <Snackbar/>
    <v-fade-transition>
      <div class="transitionBG" v-show="transition"></div>
    </v-fade-transition>
    <Calculator/>
    <Profile/>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Snackbar from '@/components/Snackbar.vue'
import Calculator from '@/components/Calculator.vue'
import Profile from '@/components/Profile.vue'
import { mapGetters, mapActions } from 'vuex' 

export default {
  name: 'App',

  data: () => ({

  }),
  components: {
    NavBar,
    Snackbar,
    Calculator,
    Profile
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      transition: 'menu/transition'
    })
  },
  methods: {
    ...mapActions({
      getData: 'data/getData'
    })
  },
  created() {
    if(this.authenticated) {
      this.getData()
    }
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: 'Pyxel';
  src: url('~@/assets/fonts/Pyxel-SemiBold.eot');
  src: url('~@/assets/fonts/Pyxel-SemiBold.eot?#iefix') format('embedded-opentype'),
      url('~@/assets/fonts/Pyxel-SemiBold.woff2') format('woff2'),
      url('~@/assets/fonts/Pyxel-SemiBold.woff') format('woff'),
      url('~@/assets/fonts/Pyxel-SemiBold.ttf') format('truetype'),
      url('~@/assets/fonts/Pyxel-SemiBold.svg#Pyxel-SemiBold') format('svg');
  font-weight: 600;
  font-style: normal;
}
.theme--light {
  .v-content {
    background-color: #003a6f;
  }
}
</style>
